import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://stockmaid.com";
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

const normalizePath = (path) => {
    if (!path || path === "/") {
        return "/";
    }

    return path.startsWith("/") ? path : `/${path}`;
};

const asJsonLdString = (jsonLd) => {
    if (!jsonLd) {
        return null;
    }

    if (typeof jsonLd === "string") {
        return jsonLd;
    }

    try {
        return JSON.stringify(jsonLd);
    } catch (error) {
        return null;
    }
};

const Seo = ({
    title,
    description,
    canonicalPath = "/",
    ogTitle,
    ogDescription,
    ogImage,
    ogType = "website",
    articlePublishedTime,
    articleModifiedTime,
    robots = "index,follow",
    jsonLd
}) => {
    const normalizedPath = normalizePath(canonicalPath);
    const canonicalUrl = `${SITE_URL}${normalizedPath}`;
    const resolvedTitle = title || "StockMaid - GPU Stock Tracker";
    const resolvedDescription = description || "Track Best Buy GPU stock in real time with StockMaid.";
    const resolvedOgTitle = ogTitle || resolvedTitle;
    const resolvedOgDescription = ogDescription || resolvedDescription;
    const resolvedOgImage = ogImage || DEFAULT_OG_IMAGE;
    const jsonLdPayload = asJsonLdString(jsonLd);

    return (
        <Helmet>
            <title>{resolvedTitle}</title>
            <meta name="description" content={resolvedDescription} />
            <meta name="robots" content={robots} />
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:type" content={ogType} />
            <meta property="og:title" content={resolvedOgTitle} />
            <meta property="og:description" content={resolvedOgDescription} />
            <meta property="og:image" content={resolvedOgImage} />
            <meta property="og:url" content={canonicalUrl} />
            {articlePublishedTime && (
                <meta property="article:published_time" content={articlePublishedTime} />
            )}
            {articleModifiedTime && (
                <meta property="article:modified_time" content={articleModifiedTime} />
            )}

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={resolvedOgTitle} />
            <meta name="twitter:description" content={resolvedOgDescription} />
            <meta name="twitter:image" content={resolvedOgImage} />

            {jsonLdPayload && (
                <script type="application/ld+json">{jsonLdPayload}</script>
            )}
        </Helmet>
    );
};

export default Seo;
